import { Grid, Typography, Button } from "@mui/material";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import React, { memo } from "react";
import "./PublicLogin.css";
import { useStableNavigate } from "@mirage/hooks/useStableNavigate";

const publicPortalRouting = new PublicPortalRoutingService();

interface PublicLoginButtonProps {
    handleSignIn: () => Promise<void>;
}

const PublicLoginButtons: React.FC<PublicLoginButtonProps> = memo(({ handleSignIn }) => {
    const navigate = useStableNavigate();
    const createAccountOnClick = () => navigate(publicPortalRouting.RegisterRoute());
    const forgotPasswordOnClick = () => navigate(publicPortalRouting.ForgotPasswordRoute());

    return (
        <Grid container spacing={2} sx={{ width: "100%" }} textAlign="center" alignItems="center" justifyContent="center">
            <Grid size={{ xs: 12, lg: 12, md: 12 }} padding="0 !important">
                <Button className="sign-in" variant="contained" onClick={handleSignIn}>
                    Sign In
                </Button>
            </Grid>
            <Grid size={{ xs: 4, lg: 4, md: 4 }} paddingLeft="0 !important">
                <Typography variant="button" onClick={forgotPasswordOnClick}>
                    Forgot password?
                </Typography>
            </Grid>
            <Grid size={{ xs: 4, lg: 4, md: 4 }} paddingLeft="0 !important">
                <Button variant="outlined" onClick={createAccountOnClick}>
                    Sign Up
                </Button>
            </Grid>
        </Grid>
    );
});

export default PublicLoginButtons;
